import { Provider } from '../domain/entities/Provider'
import { IProviderRepository } from '../domain/repositories/IProviderRepository'

export class GetProvidersUseCase {
  constructor(private readonly repository: IProviderRepository) {}

  execute(countryCode?: string): Promise<Provider[]> {
    return this.repository.getProviders(countryCode)
  }
}
